<template>
  <div class="login-wrapper">
    <img src="@/assets/images/SzTech/登录title.png" width="auto" class="titleImg" />
<!--    <div class="login-container">-->
<!--      <div class="logo">-->
<!--        <a-row-->
<!--          type="flex"-->
<!--          justify="space-around"-->
<!--          align="top"-->
<!--          style="margin-left:40px"-->
<!--          v-if="flag"-->
<!--        >-->
<!--          <a-col :span="24" class="title-wrap">-->
<!--            <img src="@/assets/images/智慧之光登录.png" alt="" />-->
<!--            <div>{{ title }}</div>-->
<!--           <span class="first">肇庆市战略性新兴产业集群</span>-->
<!--            <span class="last">中小企业转化对接平台</span>-->
<!--          </a-col>-->
<!--        </a-row>-->
<!--      </div>-->
<!--      <div class="login-form">-->
<!--        <component-->
<!--          :is="curFormConfig"-->
<!--          :formConfig="formConfig"-->
<!--          @switchForm="handleSwitch"-->
<!--        />-->
<!--      </div>-->
<!--    </div>-->
    <component
      :is="curFormConfig"
      :formConfig="formConfig"
      @switchForm="handleSwitch"
    />
    <FooterInfo></FooterInfo>
  </div>
</template>

<script>
import LoginForm from './components/LoginForm.vue'
import ForgetPswForm from './components/ForgetPswForm.vue'
import RegisterForm from './components/RegisterForm.vue'
import FooterInfo from '@/components/FooterInfo'
import {
  FORM_CONFIG_LOGIN,
  FORM_CONFIG_REGISTER,
  FORM_CONFIG_FORGET
} from './config/form'
import mixinConfigSetting from '@/mixins/mixinConfigSetting'
import mixinLogin from './mixins/index'

export default {
  mixins: [mixinConfigSetting, mixinLogin],
  components: {
    LoginForm,
    ForgetPswForm,
    RegisterForm,
    FooterInfo
  },
  data() {
    return {
      loading: false,
      curCaptchaPath: '',
      curFormConfig: '',
      formConfig: {},
      title: '',
      flag: true
    }
  },
  created() {
    this.title = process.env.VUE_APP_NAME
    console.log(process.env.VUE_APP_NAME)
    const { toComponent } = this.$route.query
    if (toComponent) {
      this.handleSwitch('register')
    } else {
      this.initSetting()
    }
  },
  mounted() {
    let key = process.env.VUE_APP_KEY
    if (key == 'Mz') {
      this.flag = false
    }
  },
  methods: {
    initSetting() {
      this.$store.dispatch('user/clearAccountInfo') // 清空用户缓存
      this.handleSwitch('login') // 表单配置
    },
    handleSwitch(type) {
      // 表单switch配置
      switch (type) {
        case 'register':
          this.curFormConfig = 'RegisterForm'
          this.formConfig = FORM_CONFIG_REGISTER
          break
        case 'forget':
          this.curFormConfig = 'ForgetPswForm'
          this.formConfig = FORM_CONFIG_FORGET
          break
        default:
          this.curFormConfig = 'LoginForm'
          this.formConfig = FORM_CONFIG_LOGIN
          break
      }
    }
  }
}
</script>

<style scoped>
.titleImg {
  position: absolute;
  top: 10%;
  left: 19%;
}
</style>

